// extracted by mini-css-extract-plugin
export default {"content":"wrebTpF_","button":"y5MxwCpU","description":"C32Pvd02"};